import React from 'react'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import Swal from 'sweetalert2'
import { toast } from 'react-toastify'
import i18n from 'i18next'
import { NavLink } from 'react-router-dom'
import CONSTANTS from '../../utils/Constants'
import { exportingMarketChangeChart } from '../../utils/AMChartsSettings'
import { toPng } from 'html-to-image'
import { RESPONSE_OBJ_NAMES } from '../../services/McDataServices'
import { COURIER, NotoSansArabicMedium, NotoSansArabicRegular } from './Base64'
import EnglishFlag from '../../images/flags/english.png'
import TurkeyFlag from '../../images/flags/turkey.png'
import SaudiArabiaFlag from '../../images/flags/saudi-arabia.png'
import { camelToFlat, LOCALE } from '../../utils/Utils'

if (pdfMake && pdfFonts?.pdfMake) {
  pdfMake.vfs = pdfFonts.pdfMake.vfs
  pdfMake.vfs['Courier.ttf'] = COURIER
  pdfMake.vfs['NotoSansArabicRegular.ttf'] = NotoSansArabicRegular
  pdfMake.vfs['NotoSansArabicMedium.ttf'] = NotoSansArabicMedium

  pdfMake.fonts = {
    NotoSans: {
      normal: 'NotoSansArabicRegular.ttf',
      bold: 'NotoSansArabicMedium.ttf',
      italics: 'NotoSansArabicRegular.ttf',
      bolditalics: 'NotoSansArabicMedium.ttf'
    },
    Roboto: {
      normal: 'Roboto-Regular.ttf',
      bold: 'Roboto-Medium.ttf',
      italics: 'Roboto-Italic.ttf',
      bolditalics: 'Roboto-Italic.ttf'
    },
    Courier: {
      normal: 'Courier.ttf'
    }
  }
}

const BASE64_ICONS = {
  LOGO: 'data:image/png;base64,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',
  GLOBE: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAACvUlEQVR4nNWXTW+MURTHf14WaGNq21CiNkpMBbuZFZ8AQb8DQtSGdfUDoGqIVksk2vEyXmqDdM0M0WpioUSCLruq0YTKaf5Pc93cZ2aeqdeTnOQ+5557/nNe7rln4D+gJqAD6AUKwDNxQbJDQOpXAm4FbgNfxXNAEXguLkoW7d8CtiwGsBG4DMwCV4G9wBRwFlgGXBTb+pz29gEDOpMDGpKCrgdeAq+AtGSPgPvAUn1HwEj2ABjRd1pnXwAtSUA/AzeBFZLtAWaADY6eC4z2ZqSLzg4Bn2oBb5Sn00DWkeeBS56uD4x0TDeirGyVqoXdcjrm5MnW3VpnawDOSLdLobZ1v+xY5cdWr1XlDn03A0eBcVXtd+Ad8FSV+0ZsHj4BJoFv0p0AjsmG0U6gDLSFgO3KXA/ILXyDwDbgINApj8bEtj6hvXbpWkX7dMNLw0JzcL11ye7q4YA8FGqka43Fp13CWO0KrSO9DygvUYgyCYCtFr7orE8fFJkFssRfCSiuUc5aEwBv0hmLok/9QI8ruAecqmAklQC4qcKPPQ3cdQWWk1HHWMR5GckF9ibEvjynM/nA3qif/78GXIgJdWuFfMWFOqqLjTGhvuMKLgB9f6C4+vzi6lCpx12n7O+6Tildbrvki20gRyo0kLLfQFD/tbbmU05tsF3jzUngjHr4uFpmpzxJV2mZwwH5/Ljier0WOK7KndMD8BZ4LAPRIzEs2aQeEtN9rQem2fN2cwg48m5Mo86s3uYurTM1hDor3W7nWRyUzZ+KyqcGjSvTHlC9g0BGtorAKqpQi8aVoTpHn936Xqk0fATWVQN1wUvesDeigS5u2HsoNtquwismAXXD3quCG9DoOqVRdrkDbOvz2tsPXNOZnlrCW4nalDd3oC/Jm6LW0UBfVnhjq5c6yC6+3VXzxP8LY7IDoebwz9EPb4sB3pOgkIUAAAAASUVORK5CYII=',
  NEWSLETTER: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAADOElEQVR4nO2ZS2gUQRCGv/gAUUxEEtSIQqKiEPAoSIQIPoMHFcSLFwXJLXhTMEb0pAcvohAEQcGDB0HUkyL4SJSA+CCC4AMRQhTBRNSAqIm2NPwDxbqzM7M7s7uR/aHYZbq66v+np3uqe6CGGqYU5gPHgOfAD9mQrvm2KYH1wAfAhZhv66DKsRf4KcJ3gQ0aAW8bdc3JZw9ViDo9NsFdPw1Mi/D7o/9lx8MCj0tWNpCFEFchSx2ZBS53PlcTUhxcbUT+90drOtAXEnggw6XWyfrEoSTMBq4VWA7TFNIfIsTbdXEpCo3AoAKNVvDRGtXvoDglQgvwUgHeAasqKGQZ8Eb/3wIr4gZYDYyooy/DF+cELhecybcQeGxGaG1U563AuDrcBOaGBC52jiSpnVxOPs/llq6Ni2sovsnxAjAzInAxQvpLEII4XdT1r8TofCamkCzhQoScjcPF3r0HQHNE4CzhcvI1AXfiVsaBw7DZlraHBM4azuRbZ7bPw0mEWPW/gO4KCukWBydOTUmEoLLgpLaksYYzZbgcO2fmbSIhAXabJdlbK9mj1eQbF4conrEc2oBXahsDOiOI1AMHgUfAd51rPQWOAPMi+nYqh1POtgQ8YznUmwLyN9CrU5FcbDaVQT57L59c+Fi9iu2Uq6EInrEcfLIeYFJ+N0yy3DZf5O3Q5PTnWpuA+2rzPofNjWhQLCchPSE3KTUhAbaY4X+t5dESORpyrjVNbfautytG8Nj62FFITYjHEs0B+9iMRdVAeeZBYM8SLCSpCvHYb/o8UfkfFy0iH/Tfl6BvakJm6B0T+F8qcgc3Czgf8q7IXEizOT71y+oBSkeXOfweABZlLcR/Dvhoap41pAe/WRoxS3R7CTwLOnSZmucesID00QjcVo4J4FARPEMd5gCXdd3XXSfSOJ6JmH+nTI2Xb/4lFrJc+3an3eMuyoftwBflHtIhRBjPf2AdtgGfI2qerLESeGG2tjvz8MyLwOG4GdorOYcQ5UY9cNVUDfbLWCjsm3ZSk61QzVMu1GmZn4i7NwocPqnIqzZ0mOU/lhBfR1UrlmZRa1UKLskcmQoWijQ/E2Rt/eEyaqiBtPAX7ThOrh810CkAAAAASUVORK5CYII=',
  PHONE: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAADS0lEQVR4nO2ZS0hUURjHf6ZZGJWUVqYWGbQSMlpkRYtE2oRBRAVFmGIYZLWM1tKqwih6CLWpXUXagx4LSVr0EiwhIm3Rg4qg1J5oz4lD/wuHYebOXBnvnIH5wd3M/c7c79x7vv/5vu9AlixpZR3QA4wCfcByMox84DgQibqGgVIyhOlAlxwfAVqAIuCyfrtOBjAHeCyH3wJLo+591L1GHGYa0CtHnwLzY9hs1f1PwDwcZBJwR04+AWb62Ha4vMQOyLlXQFkCW7PEBmVfj2MMybHVSdpvk70ZV4JDjMqxwgBjrmmMWWrO8FxOVQYYU6agN+M24wgdcsioUhB2aFw/jtAih84GHFekcb+BHBxgIfAX+AJMDTBuuyZi8jFn6JJTO5O0nwy8dFGGN1nrPS8J+/2yfwRMwCFylZoY55oT2M4CPsu2FgfZIOfeAQU+du2yMxmxk+QAD+TkQZ/Y+CqbJhxmCfAT+AOsimOzxyq0FuAwrVbgF8T5cldl8zDBMkx7qdsnR03JG4tCSxw6JRZOUqVS1zja4LORfpBNuyu7eywarNp9WUyL/50VL/jbcJijliTH66DUWF/vMI4yEbgtJ+/6BHad1C6iitNJioEXcvKGxCAWG63JtLkaM4uA93LyvI9K1VnL7JSrarZYm6Bx8rTPG6+xBKAzznLMlZiYpNNsvgNKXENjBfAticCutqS5J6pPVmvtU9HXRWA2IbEG+GFNJt6XqbA2zSGVxl5GEFHcmVqmSPe8jNp0NLeENZn11mTO+MSCyQCuRL114/A+JaA25RITz65DfbRQvoy3zC74qJn5YrsVNydVz/jRaMXioPpo485K66E3EySQpjWbLKVW7yyiJTmXEPIyT5rvpbj7WG91Qod9UqWU7jNeM+JNih9YYomEketQMoBuPXDUJ2seCzP0v98JMTc7Zq3tEykqvPZa+V6oNFjN8QGJwliptqR+LWmgytrBTRpyCJgS8D8qLCE5QhrJVw/gl1XXNCfZBCwGnmncLS3btGMOVu9bsdOv9my8XnO5ld70BuxJjzs5agJ6bzmixvk5HWlU6njcZM+vLbkNLYkMSp4Oh7p0ChCJc3VrYhmBCeZdwCWp24iy39aAKU2WLKSQf3jSBy3qRwNwAAAAAElFTkSuQmCC',
  LOCATION: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAADuElEQVR4nO2ZWYiOURjHfzRkmbHPZOJCWYZCiNwoW7JEGtkaV24VuZG9xnZBcodsxYWILJESLiQiDLIklEhqLFnGvoxPR/+3TtN8531f3znffCO/euvr/f7vc/bnOec58J9G6QBUAbuAq8BL4Luel3q3E5gLlFCAVAB7gM9AJuHzCdgN9KUAaAdsBn6ocr/U6yuB0Wpgez0VercKuCZtRqO1CWjTVI0wPXlHlakH9gO9U3zfBzhgNegyUE6eGao5byrwABiWg63hwEPZegYMJo8jETXiDNDZg80uwFmrMeX5WBN3rEYUebTdCjhnTbOga2azNZ18jERjI/NIZawhEBXyTvU5rok4RsgBfAS6hyhgj3rKeKfQHFRZ20JE7E/qqSQutgxYB9xUz5rnBrAWKE3oUH7pu2I8UqUeMsEujplAnSOivwdmJLBzXfo5eGSXjJqIHdeIKMAdUySPIvsY4LgVQCtjbK2WdofHdvwZiYwq5ppO0UgsceiWSvMO6ObQjZXuCh55JaP9HJp11kjEcSKBi+0nzQs88k1GXVvvWwlGrWFvGweQjRJpvuKRLzLqirYfpEniZaJKmqno2kVkdDTwRq2MugJUXYqGdLA8WDZ6SPMcj9yX0YEOzU1pjHeKY5y0NQ7NEGnu4pGTMjrboVkrzfEU9qodmnnSHMUjG2R0vUNTqqmSkYvNxnJp3gJdHbqNCRqbmtkyarbZLmYo2GXkYsdqzRRrOkUjYTTTY2xdlDZOl4oyFf5V3sRFpYJdti3K2wSV66Sdtnk64pkbqsiUBNpuCnY1cst12jtVx0yniFkqy4yKd6LIvZfwHEmw1v6a/pbvj5teudBRAdhsPnuFKqRGjTGuMRQLVcb5gGWwwEoOhKAIeKwyzBkoGMWWRzJna9/MtbYlJqsSlC0q7HDAqbuCPFBuLcZBHu1OsA5cJo7kha0BRsUs7qD5rMboaWVVRnmwV6lGvA6U+HNSbZ3yWuZgp7WVxF5AE9AWeKIKzM/BzhLZuOc5l/xX+a5anfrSUmq584k0IS2AS6qISXCnZZ++Ndv7Jmeors9+AiNTfDfJuktMc9MVlOiYez/hvYbJojzVN4soIFoDtxMchyO2W+eNXDxeEIZoitXHZFImKf6Y0+YACpQ16uknWbYZZUqBGs1iCpgi4IKVxjFeLcJModP671SD/wqSnlbSe2UjR+XaUFdqIZimdWDWy2Rgqn4bFz2eZka1RuCNUkDm9zKaIS2AQ1Y+q+GaaVaU6Mbpsu9LTf5VfgNttDSN+ivn8AAAAABJRU5ErkJggg=='
}
const FOR_PDF_ID = '_forPdf'
const FOR_PDF_CONTENT_ID = '_forContentPdf'

const YEAR_CHART_DATA_BG_COLORS = [
  'rgba(12, 36, 97, 0.4)',
  'rgba(12, 36, 97, 0.6)',
  'rgba(12, 36, 97, 0.8)'
]

const MOUNTAIN_CHART_TYPE = {
  MOUNTAIN: 'mountain',
  SINGLE_AXIS: 'single_axis',
  STATIC: 'static'
}

export const COUNT_FILTERS = {
  ALL_OR_EMPTY: '',
  PERMANENT: 'permanent',
  EXIT: 'exit',
  ONE: 'one',
  MULTIPLE: 'multiple',
  ZERO: 0
}

const REGISTER_STATES = {
  SUBMITTED: 'submitted',
  EXTERNAL: 'submitted-external'
}

export const FILTER_BUTTON_IDS = {
  IMPORTER_COUNT: 'importer',
  SUPPLIER_COUNT: 'supplier',
  COUNTRY_COUNT: 'country',
  HS_CODE_COUNT: 'hsCode',
  IS_LOGISTIC_FIRM: 'isLogistic',
  GROWTH: 'growth',
  NUMBER_OF_SHIPMENTS: 'numberOfShipments',
  HS_COUNT: 'hsCount',
  DISTINCT_COUNTRY: 'distinctCountry',
  HS_TOTAL_IMPORT_CURRENCY_X_FIRM_NUM: 'hsTotalImportCurrencyXFirmNum',
  AVERAGE_PRICE_X_TOTAL_IMPORT_CURRENCY: 'averagePriceXTotalImportCurrency',
  AVERAGE_PRICE_CHART: 'averagePriceChart',
  HS_CODE_CHART: 'hsCodeChart',
  AVERAGE_PRICE_X_TOTAL_IMPORT_INTEREST: 'averagePriceXTotalImportInterest'
}

export const HAS_MIN_MAX_IDS = [
  FILTER_BUTTON_IDS.NUMBER_OF_SHIPMENTS,
  FILTER_BUTTON_IDS.HS_COUNT,
  FILTER_BUTTON_IDS.DISTINCT_COUNTRY,
  FILTER_BUTTON_IDS.HS_TOTAL_IMPORT_CURRENCY_X_FIRM_NUM,
  FILTER_BUTTON_IDS.AVERAGE_PRICE_X_TOTAL_IMPORT_CURRENCY,
  FILTER_BUTTON_IDS.AVERAGE_PRICE_CHART
]

const MIN_MAX = {
  MIN: 'min',
  MAX: 'max'
}

const UNITS = {
  QUANTITY_1: 'quantity1',
  QUANTITY_2: 'quantity2',
  QUANTITY_3: 'quantity3',
  QUANTITY_4: 'quantity4'
}

const UNIT_NUMBERS = {
  N1: '1',
  N2: '2',
  N3: '3',
  N4: '4'
}

// const GROWTH_COLOR = {
//   increasing: '#00c000',
//   decreasing: '#ff0000',
//   irregular: '#00a2ff',
//   similar: '#ff8b00'
// }

function isSafari () {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
}

const safariStyle = isSafari() ? { transform: 'rotate(180deg)' } : {}

const GROWTH_ICONS = {
  increasing: <img src="/assets/icons/up.svg" width="14" height="14" style={safariStyle} alt=""/>,
  decreasing: <img src="/assets/icons/down.svg" width="18" height="18" alt=""/>,
  irregular: <img src="/assets/icons/pulse.svg" width="14" height="14" alt=""/>,
  similar: <img src="/assets/icons/minus.svg" width="16" height="16" alt=""/>
}

const GROWTH_ICONS_BASE64 = {
  '/assets/icons/up.svg': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAKJlWElmTU0AKgAAAAgABgESAAMAAAABAAEAAAEaAAUAAAABAAAAVgEbAAUAAAABAAAAXgEoAAMAAAABAAIAAAExAAIAAAARAAAAZodpAAQAAAABAAAAeAAAAAAAAABgAAAAAQAAAGAAAAABd3d3Lmlua3NjYXBlLm9yZwAAAAOgAQADAAAAAQABAACgAgAEAAAAAQAAAECgAwAEAAAAAQAAAEAAAAAAhSg4jgAAAAlwSFlzAAAOxAAADsQBlSsOGwAAActpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDYuMC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iCiAgICAgICAgICAgIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyI+CiAgICAgICAgIDx0aWZmOk9yaWVudGF0aW9uPjE8L3RpZmY6T3JpZW50YXRpb24+CiAgICAgICAgIDx4bXA6Q3JlYXRvclRvb2w+d3d3Lmlua3NjYXBlLm9yZzwveG1wOkNyZWF0b3JUb29sPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4K56DsKAAAAtFJREFUeAHtm8Fu1DAQhv9ULW8Aqrj1tCvtA6AK1HZ7og9SpBUceY2eiir10KegUi/QgtRWQtrrdnvlChcOXKCFME5kdZXEcXbWHq+MLa2STDz2/J8nip1sgFT+bwJZMPkXWEWOZ0X/Gb5giPsQsayE6BQXWEeGa6zgsvipfWULUOQz4BJPaazPSWuvoneCNeziOb5V7F4PZQGYxWuR4hDkANjFB4EgA6C7eHEI/gHML14Ugl8AfPFiEPwBWFy8CAQ/8wB1T7/HR1JQvdVpUb/0zsy2yaZOD3CHz77mCe4BqJHP8IkC76voG8oR2d7X7BlOaWZ4UrOXhj61+QFXeGI4zza7BWBP+yNs4w1Fm9cizvEXO3jVAkFlwrlrCO4AdBWfNYjXNDJ5CG4AuBAfCMLiAFyKDwBhMQA+xAtD4APwKV4QAg+AhHghCPMDkBQvAGE+ACHEe4bQHUBI8R4hdAOwDOI9QbADUPPvtoVNjuNiets2w9PBu9qWM8Z9mlMeG5osF1Ad1g52AHd4R500L2xUADsY0UKlPrc3RObMrPpUfZsh9Gng1MKrtdgBAC8bWwgpXgdkg5BjT1c1bbsAmNacl0G8Dqodwq2uZtraAeR4Tc76WX1OKXdQpF6ItDepeIBwQFX05fidXrqMTC7avqp3jNshxvQ0pkfX+SY1+BVbuDHWDXmiHJC39OxIPVTZoIX1NcX6wxaSHYBqYVg0dGZrbCnOb0NdsvXL1hCc/RIwOMZiTgBiGUmujpQBXHKx+KUMiGUkuTpSBnDJxeKXMiCWkeTqSBnAJReLX8qAWEaSqyNlAJdcLH4pA2IZSa6OlAFccrH4pQyIZSS5OlIGcMnF4pcyIJaR5OoIkwHqj9HV0mSr1vFwHAZA1viG2fou34N+euEdojwq/nYzmel6ij84nDkW2/X3yYxNwpg+k/yJF0W1x/QVwAC/bS7pfCLgnsA/uTkCcW2LldYAAAAASUVORK5CYII=',
  '/assets/icons/down.svg': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAAV1BMVEUAAAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD////XqVM0AAAAG3RSTlMAAQQFBwkLDA0eHyEjPm5wgoOvtLrL0tPe4OKd7+AJAAAAAWJLR0QcnARBBwAAALVJREFUWMPt1ssOgjAURdGioGAFtKBS9///pwNe1WCgbaKTe+Z7pbNbpWQy2S+W1nUaBVzhEgUYMAIIIIAAfwOOZf4NyMvDer9/0OllQHfcd6vACbB6CdAWKFaBpHEFB9AWaJINp6ABnudPoOiANtt0TBxhAjz6N2EEvHpXGADP3hF6wLufBQMmpJ8EAyaoVyprAXuDmw3qhzcMC+ldIayfhdB+FML7XojplUqrKu6TJZPJtu4F8QYa98HwwVwAAAAASUVORK5CYII=',
  '/assets/icons/pulse.svg': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAB11BMVEUAAAAA//8AgP8Aqv8Av/8Amf8Akv8An/8Aqv8Amf8Aov8Aqv8Anf8ApP8Aqv8An/8Apf8AnP8Aof8Anv8Apv8An/8Ap/8ApP8Aov8Apf8An/8Ao/8Apf8Ao/8ApP8AoP8ApP8Ao/8An/8Aov8ApP8Aof8AoP8Ao/8AoP8Aov8Aov8ApP8Aof8Aof8Aov8Ao/8Aof8Aof8Aov8Ao/8Ao/8Aof8Ao/8Aov8Ao/8Aof8Aof8Aov8Aov8Aov8Aof8Aov8Aof8Aov8Aof8Aov8Aof8Aov8Aov8Aov8Aov8Aof8Ao/8Aof8Ao/8Aof8Aov8Aof8Ao/8Aov8Ao/8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aof8Aov8Aov8Aov8Aov8Aov8Aof8Aov8Aov8Ao/8Ao/8Aov8Aof8Ao/8Aov8Ao/8Aov8Aov8Aov8Aov8Aov8Ao/8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aof8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aov8Aof4Aov/////lz0JpAAAAmnRSTlMAAQIDBAUHCAkKCwwNDg8QERITFRcYGhweHyAkJScqKy0vMDQ1OTs9Pj9CQ0RJTU5PUVJTVldZXV5fYmNlaGprbW5yc3V2eHl7fX+AgoWHiIqMjY6RkpSWl5qbnJ2hoqWmqKqrrq+xtri5uru+v8DExcbKy83Q0dXW2Nna3N3e3+Hi4+Tm6Onr7O3u7/Hy8/T19vf4+fr7/P3+c85nlAAAAAFiS0dEnHG8wicAAAKjSURBVBgZpcGLQ1NlHMfh7zYX3SgpFUsjhLQSyMpLNzVbapFmZSEmWnSDclSSmJWKlWmFqKRY2z7/bGfv72w7ZztbndfnUbP8AkzoDgwBl7PyN0Zgo/zNEzgkbwNUnZW3t3DWy9ccTkGeess438jTbszfDynRWv2Hk4ReVKJP+tVR9zKhz5Tk3hvj6mg7Nde7lOAFlnrUySR1I0owDQV1kF+g7qhaPXwbLmTV3hANlzJqsZvAM2pvjIhBtfiWwEm1N0/EQTVbW6aqX+0MEHVGzd7AGVc7o8Q8oibf49x4UG3MEbNHcX0EKkBByXrLOBcxRcW9TaACXMgq0auYfWdxbq9UVGaemi1K9BXmsUOYHYraRF1RSbqXcc5pI2ZSUUdo6FeCbZh3lb2MczWvhhVXMBVgXAk+xmySJjDDahghYqlHLfILOFdy0hbMmBo+IqqgFkOY45LuXsL5OaOarkWiLuZUUwydwzyrwBRmg2q20VABThVDIu6vexR4BTOqmi8wMzQRcVOqWlXCOa3Qyls4f6xeIk7EvSxnFqfcK7MTM64PiRMxpdVy9mN2ycxgntTjZWJEzCmZPsy0nDUlnF+y0tfEiJi9Cv2Ec+t+VRUw70h6nhgVY9Yr9B5mq6q+wwxIyn1ejFIbT2FOKLAO84P+v9zvOH+ukHQA86ZSOIF5WtKPmHVKYSvmsDSImVUa993EOS8dxuxRKtOYvuwlnH9WKZVdmP2bMV8qnTVlnNljmJeU0mmc0iLOzW6lNErMp0prAzHPKbV5Iha7lNoHREwovWGgQmhY6eWvUvdbTh4mqXtfPnZQ94R8PLBM6HxGXoqEDsjPa4T65OdRzJx8ncF5Xb4OUlXqla9BqmbkLfMrgZ3ydxRY7pG/EWBKd+Cua7BdHfwL/bivTvfXrhsAAAAASUVORK5CYII=',
  '/assets/icons/minus.svg': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABAAgMAAADXB5lNAAAACVBMVEUAAAD/iwD///+hL+WdAAAAAXRSTlMAQObYZgAAAAFiS0dEAmYLfGQAAAAWSURBVDjLY2AYBSMchEIBJQKjYIQCAJmKCqFHFYZ9AAAAAElFTkSuQmCC'
}

const HEAT_MAP_PARAMS = {
  AVG_PRICE: 'avg_price1',
  TOTAL_VALUE: 'hs_total_value',
  TOTAL_NUMBER_OF_COMPANY: 'total_company',
  TRADE_MAP_TOTAL_IMPORT: 'comtrade_import_value',
  YVALUE: 'yValue'
}

const MESSAGE_TYPES = {
  CREDIT_CHECK: 'marketreport_creditcheck',
  COM_TRADE: 'marketreport_comtrade',
  MARKET_CHANGES: 'marketreport_marketchanges',
  RF_TABLE: 'marketreport_rftable',
  SP_TABLE: 'marketreport_sptable',
  SP_GRAPH: 'marketreport_spgraph',
  SP_SUMMARY: 'marketreport_spsummary',
  MONTHLY: 'marketreport_monthly'
}

const MESSAGE_TYPES_NEGATIVE = {
  CREDIT_CHECK: 'marketreport_creditcheck_failed',
  COM_TRADE: 'marketreport_comtrademarketoverview_failed',
  MARKET_CHANGES: 'marketreport_marketchanges_failed',
  RF_TABLE: 'marketreport_rftable_failed',
  SP_TABLE: 'marketreport_sptable_failed',
  SP_GRAPH: 'marketreport_spgraph_failed',
  SP_SUMMARY: 'marketreport_spsummary_failed',
  MONTHLY: 'marketreport_monthly_failed'
}

const SECTION_IDS = {
  IMPORTER_COMPANIES: 'importerCard',
  IMPORTER_COMPANIES_MAP_GRAPH: 'importerCardMapGraph',
  POTENTIAL_COMPANIES: 'potentialCard',
  POTENTIAL_COMPANIES_MAP_GRAPH: 'potentialCardMapGraph',
  ANNUAL_AVERAGE_IMPORT_UNIT_PRICES_MAP_GRAPH: 'annualAverageImportUnitPricesMapGraph',
  ANNUAL_AVERAGE_IMPORT_UNIT_PRICES_WORLD_MAP_GRAPH: 'annualAverageImportUnitPricesWorldMapGraph',
  SUMMARY_TABLES: 'summaryTable'
}

export const REQUEST_STATUSES = {
  IDLE: 'idle',
  REQUESTED: 'requested',
  SUCCESS: 'success',
  ERROR: 'error'
}

const ALLOWED_REFERRER_LIST = [
  'https://inventmarketdata.com/',
  'https://marketcalculus.ai/'
]

export const isReferrerAllowed = () => ALLOWED_REFERRER_LIST.some((item) => document.referrer.includes(item))

const generateCountFilterValue = (value) => {
  switch (value) {
    case '000':
    case '001':
    case '011':
    case '010':
    case '110':
    case '100':
    case '101':
      return COUNT_FILTERS.EXIT
    case '111':
      return COUNT_FILTERS.PERMANENT
    case 0:
      return COUNT_FILTERS.ZERO
    case 1:
      return COUNT_FILTERS.ONE
    default:
      return COUNT_FILTERS.MULTIPLE
  }
}

const generateYearChartData = (yearArr = [], spYearsAgo) => {
  const labels = yearArr.slice(0).reverse().map(item => `${item.year} ${spYearsAgo} \n${numToLocaleString(item.percentage, 'percent')}`)
  const data = yearArr.slice(0).reverse().map(item => item.percentage * 100)

  return {
    labels,
    dataUnit: 'USD',
    stacked: true,
    datasets: [
      {
        backgroundColor: YEAR_CHART_DATA_BG_COLORS,
        barPercentage: 0.7,
        categoryPercentage: 0.7,
        data
      }
    ]
  }
}
const generateYearModalChartData = (yearArr = []) => {
  return yearArr?.map(item => ({
    xValue: item.year + ' ' + i18n.t('sp_years_ago'),
    yValue: item.percentage * 100,
    description: item.year + ' ' + i18n.t('sp_years_ago') + '\n' + numToLocaleString(item.percentage, 'percent')
  })).reverse()
}

const getCompanyLogisticFirmStatus = (item) => {
  if (item.company_type_code === 0) {
    return false
  }
  return true
}

const numToLocaleString = (number, type = 'decimal', isMarketShare, maximumFractionDigits, minimumFractionDigits, operator, value) => {
  const userLang = localStorage.getItem('lang')
  const userLocale = localeMap[userLang] || 'en-US'
  localStorage.setItem('locale', userLocale)
  const option = { style: type, currency: 'USD' }
  if (type === 'percent') option.maximumFractionDigits = 2
  if (isMarketShare && number === 0) {
    number = 0.0001
  }
  if (maximumFractionDigits) option.maximumFractionDigits = maximumFractionDigits
  if (minimumFractionDigits) option.minimumFractionDigits = minimumFractionDigits

  // eslint-disable-next-line no-eval
  if (value) number = eval(`number${operator}${value}`)

  let string = number ? number.toLocaleString(userLocale, option) : ''
  if (number === 0) string = Number(0).toLocaleString(userLocale, option)

  return string !== 'Infinity' ? string : '∞'
}

const numDivisionByThousand = (number) => {
  return number / 1000
}

const getCountryDataByCode = (countries, countryCode) => {
  return countries?.filter(country => country.countryCode === countryCode)[0]
}

const getFilterCondition = (filters, filterName, selectedUnitNumber) => {
  const filterParams = []
  for (const filter in filters) {
    if (filters[filter] !== McPageHelpers.COUNT_FILTERS.ALL_OR_EMPTY && typeof filters[filter] !== 'object') {
      filterParams.push(`(item.${filterName}.${filter} === ${filterName}.${filter})`)
    } else if (McPageHelpers.HAS_MIN_MAX_IDS.includes(filter)) {
      switch (filter) {
        case McPageHelpers.FILTER_BUTTON_IDS.HS_TOTAL_IMPORT_CURRENCY_X_FIRM_NUM:
          if (filters[filter].doFilter && filters[filter].min !== McPageHelpers.COUNT_FILTERS.ALL_OR_EMPTY) filterParams.push(`(item.hsTotalValue >= ${filterName}.${filter}.min)`)
          if (filters[filter].doFilter && filters[filter].max !== McPageHelpers.COUNT_FILTERS.ALL_OR_EMPTY) filterParams.push(`(item.hsTotalValue <= ${filterName}.${filter}.max)`)
          break
        case McPageHelpers.FILTER_BUTTON_IDS.AVERAGE_PRICE_X_TOTAL_IMPORT_CURRENCY:
        case McPageHelpers.FILTER_BUTTON_IDS.AVERAGE_PRICE_CHART:
          if (filters[filter].doFilter && filters[filter].min !== McPageHelpers.COUNT_FILTERS.ALL_OR_EMPTY) filterParams.push(`(item.avgPrice${selectedUnitNumber} >= ${filterName}.${filter}.min)`)
          if (filters[filter].doFilter && filters[filter].max !== McPageHelpers.COUNT_FILTERS.ALL_OR_EMPTY) filterParams.push(`(item.avgPrice${selectedUnitNumber} <= ${filterName}.${filter}.max)`)
          break
        default:
          if (filters[filter].min !== McPageHelpers.COUNT_FILTERS.ALL_OR_EMPTY) filterParams.push(`(item.${filter} >= ${filterName}.${filter}.min)`)
          if (filters[filter].max !== McPageHelpers.COUNT_FILTERS.ALL_OR_EMPTY) filterParams.push(`(item.${filter} <= ${filterName}.${filter}.max)`)
      }
    }
  }

  return filterParams.join('&&')
}

const showLoadingWithTimer = (title = '', timer = '3000') => {
  let timerInterval
  Swal.fire({
    title,
    timer,
    timerProgressBar: true,
    didOpen: () => {
      Swal.showLoading()
    },
    willClose: () => {
      clearInterval(timerInterval)
    }
  }).then((result) => {
    if (result.dismiss === Swal.DismissReason.timer) {
      //
    }
  })
}

const showFilterNotification = (title, filteredTable, rawTable, link) => {
  let text = ''
  if (filteredTable?.length !== rawTable?.length) {
    text = i18n.t('sp_filtered_toast', {
      filtered: filteredTable?.length,
      total: rawTable?.length
    })
  } else {
    text = i18n.t('sp_not_filtered_toast', {
      total: rawTable?.length
    })
  }

  const toastHtml = <div className="d-flex flex-column">
    <span className="pb-1">{title} {text}</span>
    <div className="w-75">
      <NavLink className="text-muted link-button"
               to={link}> {i18n.t('sp_navigate_table')} </NavLink>
    </div>
  </div>

  rawTable?.length && toast.info(toastHtml, {
    position: 'bottom-right',
    autoClose: true,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: false
  })
}

const parseAndFindCountryName = (customMessage) => {
  return customMessage?.split(',').map(item => findCountryName(item))
}

const generateRawErrorList = (header, errors) => {
  let html = `<div class="error-body"><h5><em class="icon ni ni-cross-circle"></em> ${i18n.t(header)}</h5>`
  if (errors.length) {
    html += '<ul>'
    for (const error of errors) {
      html += `<li><em class="icon ni ni-chevron-right-circle-fill"></em> ${i18n.t(error)}</li>`
    }
    html += '</ul></div>'
  }
  return html
}

const handleRawError = (errors) => {
  const dataSources = errors?.map(error => error.dataSource)
  let title = ''

  const firmAnalysis = dataSources.filter(item => item === 'output.trade_pattern_graphs' || item === 'output.trade_pattern_results' || item === 'output.company_recommendation_results')

  if (firmAnalysis?.length) {
    title += generateRawErrorList('marketreport_firmAnalysis_failed', firmAnalysis)
  }

  if (dataSources.includes('comtrade')) {
    title += generateRawErrorList('marketreport_comtrademarketoverview_failed', ['marketreport_comtrademarketoverview_value_failed', 'marketreport_comtrademarketoverview_quantity_failed', 'marketreport_comtrademarketoverview_avgPrice_failed'])
  }

  if (dataSources.includes('mc-marketchange') && dataSources.includes('comtrade')) {
    title += generateRawErrorList('marketreport_changes_failed', ['marketreport_comtrademarketchange_failed', 'marketreport_marketchanges_failed'])
  }

  if (dataSources.includes('mc-marketchange') && !dataSources.includes('comtrade')) {
    title += generateRawErrorList('marketreport_changes_failed', ['marketreport_comtrademarketchange_failed'])
  }

  if (!dataSources.includes('mc-marketchange') && dataSources.includes('comtrade')) {
    title += generateRawErrorList('marketreport_changes_failed', ['marketreport_marketchanges_failed'])
  }

  if (dataSources?.includes('output.trade_pattern_monthly')) {
    title += generateRawErrorList('monthly_changes_failed', ['monthly_changes_failed'])
  }

  if (dataSources?.includes('comtrade-summary')) {
    title += generateRawErrorList('summary_tables_failed', ['summary_tables_failed'])
  }

  if (dataSources?.includes('summary')) {
    title += generateRawErrorList('summary_tables_failed', ['summary_tables_failed'])
  }

  if (dataSources?.includes('duties')) {
    title += generateRawErrorList('customs_duties_failed', ['customs_duties_failed'])
  }

  if (dataSources?.length) {
    Swal.fire({
      icon: 'error',
      title,
      customClass: 'swal-wide',
      focusConfirm: false
    })
  }
}

const handleError = (error) => {
  let title = ''
  let text = ''
  const type = error?.data?.detail?.ruleType

  switch (error?.status) {
    case 401:
      text = i18n.t('marketreport_bad_request_401_message')
      break
    case 402:
      if (type === 'HS_CODE_SET') {
        title = i18n.t('error_hs_code_set_text')
        text = `${error.data.detail.customMessage?.replace(',', ', ')}`
      } else if (type === 'HS_CODE_COUNT') {
        title = i18n.t('error_hs_code_limit_text')
        text = `${error.data.detail.customMessage?.replace(',', ', ')}`
      } else if (type === 'MARKET_REPORT_DAILY_SEARCH_COUNT') {
        title = `${i18n.t('error_daily_search_limit_text')} ${error.data?.detail.limit}`
      } else if (type === 'MARKET_REPORT_TOTAL_SEARCH_COUNT') {
        title = `${i18n.t('error_market_report_total_search_limit_text')} ${error.data?.detail.limit}`
      } else if (type === 'SEARCH_COUNTRY_SET') {
        title = i18n.t('error_search_country_set_text', { exporter: error.data.detail.customMessage ? parseAndFindCountryName(error.data.detail.customMessage) : '' })
        text = `${error.data.detail.customMessage ? parseAndFindCountryName(error.data.detail.customMessage) : ''}`
      } else title = i18n.t('marketreport_bad_request_401_message')
      break
    default:
      title = i18n.t('marketreport_bad_request_401_message')
  }

  Swal.fire({
    icon: 'error',
    title,
    text,
    focusConfirm: false
  })
}

const sanitizeQuantity = (quantity) => {
  return quantity?.replaceAll(' ', '_')
    .replaceAll('%', '')
    .replaceAll('/', '')
    .replaceAll('(', '')
    .replaceAll(')', '')
    .replaceAll(',', '')
}

const generateCardHyperlink = (row) => {
  let link = row.web
  if (link?.startsWith('.')) link = link.replace('.', '')
  if (link && !link?.startsWith('https')) link = 'http://' + link.replaceAll('http://', '')
  return <a style={{ fontSize: '12px' }} target="_blank" rel="noreferrer" href={link}>{link}</a> ?? ''
}

const mcDataTableCustomSort = (rows, selector, direction) => {
  return rows?.sort((rowA, rowB) => {
    let aField = selector(rowA)
    let bField = selector(rowB)
    let comparison = 0

    if (aField === '' || aField === '-') aField = -1
    if (bField === '' || bField === '-') bField = -1

    if (aField.toString().includes('<') || !aField) aField = 0
    if (bField.toString().includes('<') || !bField) bField = 0

    if (localStorage.getItem('locale') === LOCALE.TR_TR) {
      if (typeof aField === 'string') aField = aField.replaceAll(/[.$%]/g, '').replaceAll(',', '.')
      if (typeof bField === 'string') bField = bField.replaceAll(/[.$%]/g, '').replaceAll(',', '.')
    } else {
      if (typeof aField === 'string') aField = aField.replaceAll(/[,$%]/g, '')
      if (typeof bField === 'string') bField = bField.replaceAll(/[,$%]/g, '')
    }

    if (Math.round(aField) > Math.round(bField)) comparison = 1
    else if (Math.round(aField) < Math.round(bField)) comparison = -1

    return direction === 'desc' ? comparison * -1 : comparison
  })
}

export const findCountryName = (value) => {
  if (value === 'GB') {
    value = 'UK'
  } else if (value === 'XK') {
    value = 'KV'
  }

  let country
  try {
    country = JSON.parse(localStorage.getItem('countries'))
  } catch (e) {
    country = []
  }

  const founded = country?.find(t => t.countryCode === value || t.countryId === value)

  if (value === 'World' || value === 0 || value === CONSTANTS.WORLD_COUNTRY_CODE) return i18n.t('world')

  if (value === -1) return i18n.t('sp_other_countries')

  return founded?.countryName ?? value
}

export const findCountry = (value) => {
  if (value === 'GB') {
    value = 'UK'
  } else if (value === 'XK') {
    value = 'KV'
  }

  let country
  try {
    country = JSON.parse(localStorage.getItem('countries'))
  } catch (e) {
    country = []
  }

  const founded = country?.find(t => t.countryCode === value || t.countryId === value)

  return founded
}

const findSelectedFirmDetails = (id, tableName, state) => {
  switch (tableName) {
    case McPageHelpers.SECTION_IDS.IMPORTER_COMPANIES:
      return state.rawImporterTable.filter(item => item.id === id)[0]
    case McPageHelpers.SECTION_IDS.POTENTIAL_COMPANIES:
      return state.rawPotentialTable.filter(item => item.id === id)[0]
    default:
      break
  }
}

const unitToNumber = (selectedUnit) => {
  switch (selectedUnit) {
    case UNITS.QUANTITY_1:
      return UNIT_NUMBERS.N1
    case UNITS.QUANTITY_2:
      return UNIT_NUMBERS.N2
    case UNITS.QUANTITY_3:
      return UNIT_NUMBERS.N3
    case UNITS.QUANTITY_4:
      return UNIT_NUMBERS.N4
    default:
      break
  }
}

const getBarChartFilterValues = (barChartFilter) => {
  let min
  let max

  if (barChartFilter.includes('-')) {
    const splitString = barChartFilter.split('-').map(Number)
    min = Math.min(...splitString)
    max = Math.max(...splitString)
  }
  if (barChartFilter.includes('+')) {
    min = Math.round(barChartFilter.split('-').join(''))
    max = COUNT_FILTERS.ALL_OR_EMPTY
  }

  return { min, max }
}

const getMonthName = (value) => {
  if (value === Months.January) {
    return 'january'
  }
  if (value === Months.February) {
    return 'february'
  }
  if (value === Months.March) {
    return 'march'
  }
  if (value === Months.April) {
    return 'april'
  }
  if (value === Months.May) {
    return 'may'
  }
  if (value === Months.June) {
    return 'june'
  }
  if (value === Months.July) {
    return 'july'
  }
  if (value === Months.August) {
    return 'august'
  }
  if (value === Months.September) {
    return 'september'
  }
  if (value === Months.October) {
    return 'october'
  }
  if (value === Months.November) {
    return 'november'
  }
  if (value === Months.December) {
    return 'december'
  }
}

const Months = {
  January: '01',
  February: '02',
  March: '03',
  April: '04',
  May: '05',
  June: '06',
  July: '07',
  August: '08',
  September: '09',
  October: '10',
  November: '11',
  December: '12'
}

const KEY = {
  MONTHLY: 'monthly',
  YEARLY: 'yearly'
}

const scrollToElement = (id) => {
  const element = document.getElementById(id)

  if (element) {
    const topOffset = element.getBoundingClientRect().top
    window.scrollBy({
      top: topOffset - 78,
      behavior: 'smooth'
    })
  }
}

const generatePriceAnalysisMultiValueAxes = (values, dates) => {
  return dates?.map((date, index) => {
    const dateStr = date?.toString()
    const year = Math.round(dateStr.substring(0, 4))
    const month = Math.round(dateStr.substring(4, 6)) - 1
    const dateObj = new Date(year, month)

    return {
      date: dateObj?.getTime(),
      value: values[index]
    }
  })
}

const getYearAndMonth = (value, type) => {
  if (!value) return ''
  if (type === 'yearly') return '(' + value + ')'
  if (value) {
    const date = value?.toString()
    const lastTwoCharacter = date.slice(-2)
    const firstFourCharacter = date.slice(0, 4)
    const result = getMonthName(lastTwoCharacter)
    return '(' + firstFourCharacter + '/' + i18n.t(`months.${result}`) + ')'
  }
}

const checkPasswordValidity = (password) => {
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/
  return regex.test(password)
}

const createAboutSection = (pageBreak, isToc, p1) => {
  return {
    columns: [
      {
        stack: [
          {
            text: isToc ? i18n.t('pdf_about.title') : i18n.t('pdf_about.title').toUpperCase(),
            alignment: 'center',
            color: 'black',
            bold: true,
            fontSize: 16,
            margin: [0, 50, 0, 15],
            tocItem: isToc ? ['mainToc', 'subToc'] : ''
          },
          {
            text: i18n.t(p1),
            lineHeight: 0.8,
            alignment: 'justify',
            color: 'gray',
            fontSize: 12,
            margin: [20, 10, 50, 10]
          },
          {
            text: i18n.t('pdf_about.p2'),
            lineHeight: 0.8,
            alignment: 'justify',
            color: 'gray',
            fontSize: 12,
            margin: [20, 10, 50, 10]
          },
          {
            text: i18n.t('pdf_about.p3'),
            lineHeight: 0.8,
            alignment: 'justify',
            color: 'gray',
            fontSize: 12,
            margin: [20, 10, 50, 10]
          },
          {
            text: i18n.t('pdf_about.p4'),
            lineHeight: 0.8,
            alignment: 'justify',
            color: 'gray',
            fontSize: 12,
            margin: [20, 10, 50, 10]
          },
          {
            text: i18n.t('pdf_about.p5'),
            lineHeight: 0.8,
            alignment: 'justify',
            color: 'gray',
            fontSize: 12,
            margin: [20, 10, 50, 10]
          }
        ],
        pageBreak: pageBreak ? 'before' : null,
        pageOrientation: 'portrait'

      }
    ]
  }
}

const PDFExport = (content, header, subHeader, isFullPdf, p1) => {
  content[content.length - 1].pageBreak = null

  // const [hsCode, importingCountryName, exportingCountryName] = subHeader.split(' - ')
  const [hsCode, importingCountryName] = subHeader.split(' - ')
  const docDefinition = {
    info: {
      title: i18n.t('app_name'),
      author: 'Market Calculus'
    },
    watermark: { text: 'Market Calculus', color: 'gray', opacity: 0.1, bold: true, italics: false, fontSize: 72 },
    pageMargins: [20, 40, 20, 40],
    pageOrientation: 'portrait',
    styles: {
      tocHeaderItemStyle: {
        fontSize: 14,
        bold: false,
        font: 'Courier'
      },
      tocSubItemStyle: {
        fontSize: 8,
        bold: false,
        font: 'Courier'
      }
    },
    header: (currentPage, pageCount) => {
      if (currentPage === 1 || currentPage === pageCount) return ''
      return {
        image: BASE64_ICONS.LOGO,
        width: 50,
        // text: i18n.t('app_name'),
        alignment: 'center',
        marginTop: 20
      }
    },
    footer: (currentPage, pageCount) => {
      if (currentPage === 1 || currentPage === pageCount) return ''
      return {
        text: `${currentPage} / ${pageCount}`,
        alignment: 'center',
        marginTop: 10
      }
    },
    defaultStyle: {
      font: 'NotoSans',
      fontSize: 12,
      lineHeight: 0.8
    },
    content: content
      ? [
          {
            columns: [
              { width: '*', text: '' },
              {
                width: '55%',
                stack: [
                  {
                    text: [
                      { text: hsCode + ' - ' },
                      importingCountryName ? importingCountryName + ' ' : ''],
                    alignment: 'center',
                    color: 'black',
                    bold: true
                  },
                  {
                    text: header ?? i18n.t('app_name'),
                    alignment: 'center',
                    color: 'black',
                    bold: true
                  }
                ]
              },
              { width: '*', text: '' }
            ],
            color: 'gray',
            fontSize: 36,
            marginTop: 200,
            pageOrientation: 'portrait'
          },
          {
            text: '(' + localStorage.getItem('hs') + ')' ?? '',
            alignment: 'center',
            marginTop: 14,
            color: 'gray',
            fontSize: 16
          },
          {
            image: BASE64_ICONS.LOGO,
            alignment: 'center',
            marginTop: 250,
            width: 100
          },
          {
            text: 'www.marketcalculus.ai',
            link: 'https://marketcalculus.ai/',
            alignment: 'center',
            fontSize: 8,
            marginTop: 12,
            pageBreak: isFullPdf && 'after'
          },

          ...(isFullPdf ? [] : [McPageHelpers.createAboutSection(true, null, p1)]),

          ...(!isFullPdf
            ? [{
                text: '',
                pageBreak: 'before',
                pageOrientation: 'landscape'
              }]
            : []),
          ...content,
          {
            image: BASE64_ICONS.LOGO,
            alignment: 'center',
            marginTop: 150,
            pageBreak: 'before',
            pageOrientation: 'portrait'
          },
          {
            image: BASE64_ICONS.GLOBE,
            width: 30,
            height: 30,
            marginTop: 50,
            alignment: 'center'
          },
          {
            text: 'www.marketcalculus.ai',
            link: 'https://marketcalculus.ai/',
            alignment: 'center',
            fontSize: 14,
            marginTop: 10
          },
          {
            image: BASE64_ICONS.NEWSLETTER,
            width: 30,
            height: 30,
            marginTop: 20,
            alignment: 'center'
          },
          {
            text: 'info@marketcalculus.ai',
            link: 'mailto:info@marketcalculus.ai',
            alignment: 'center',
            fontSize: 14,
            marginTop: 10
          },
          {
            image: BASE64_ICONS.PHONE,
            width: 30,
            height: 30,
            marginTop: 20,
            alignment: 'center'
          },
          {
            text: '+90 552 805 54 96',
            alignment: 'center',
            fontSize: 14,
            marginTop: 10
          },
          {
            image: BASE64_ICONS.LOCATION,
            width: 30,
            height: 30,
            marginTop: 20,
            alignment: 'center'
          },
          {
            text: 'Koru Mah. 2562. Sok Azat Bey Sitesi No:15, Çankaya-Ankara',
            alignment: 'center',
            fontSize: 14,
            marginTop: 10
          }
        ]
      : []
  }

  pdfMake.createPdf(docDefinition).download(header + ' --- ' + subHeader + '.pdf') // .open()
}

const captureImageById = async (divId, selectedComponentIds) => {
  const container = document.getElementById(divId)
  const containerMain = document.getElementById(divId.replace(FOR_PDF_ID, ''))
  const parent = document.getElementById(divId.replace(FOR_PDF_ID, FOR_PDF_CONTENT_ID))

  if (!container) {
    console.error(`Error: Element with ID '${divId}' not found.`)
    return ''
  }

  const isAnyLoading = [container, containerMain, parent].some(element =>
    element?.classList.contains('loading-div')
  )

  const isSelected = selectedComponentIds.includes(divId.replace('_withTitle', '').replace(FOR_PDF_ID, ''))

  if (isAnyLoading || !isSelected) { //  || isNotSelected
    return null // Temporary fix for cleanseDataForPdf function
  }

  try {
    const image = await toPng(container, { skipAutoScale: true })
    return image
  } catch (error) {
    console.error(`Error capturing image: ${error.message}`)
    console.error(`Error capturing divId: ${divId}`)
    return null
  }
}

const generateTocTitle = (title, type) => {
  let lenLimitForDot = 57
  if (type === 'subToc') lenLimitForDot = 97
  return title + ' ' + (title.length > lenLimitForDot ? '' : '.'.repeat(lenLimitForDot - title.length))
}
const generateSectionTitle = (title, pageBreak = 'before', type) => {
  const sectionTitle = [
    {
      text: '',
      pageOrientation: 'landscape'
    },
    {
      text: '',
      pageOrientation: 'landscape',
      pageBreak
    },
    {
      text: generateTocTitle(title, type),
      fontSize: 0,
      alignment: 'center',
      pageOrientation: 'landscape',
      tocItem: ['mainToc', 'subToc'],
      tocMargin: type === 'mainToc' ? [0, 0, 0, 0] : [20, 0, 0, 0],
      tocStyle: type === 'mainToc' ? 'tocHeaderItemStyle' : 'tocSubItemStyle',
      tocNumberStyle: type === 'mainToc' ? 'tocHeaderItemStyle' : 'tocSubItemStyle'
    }
  ]

  if (type === 'mainToc') {
    sectionTitle.push({
      text: title,
      bold: true,
      fontSize: 24,
      alignment: 'left',
      pageOrientation: 'landscape',
      marginTop: 5
    })
  }

  return sectionTitle
}

const generateSubTitle = (title, pageBreak = 'before') => {
  return [
    {
      text: '',
      pageOrientation: 'landscape'
    },
    {
      text: '',
      pageOrientation: 'landscape',
      pageBreak
    },

    {
      text: generateTocTitle(title),
      fontSize: 0,
      alignment: 'center',
      pageOrientation: 'landscape',
      tocItem: 'subToc'
    },
    {
      text: title,
      bold: true,
      fontSize: 8,
      alignment: 'center',
      pageOrientation: 'landscape',
      marginTop: 5
    }
  ]
}
const generateTableTitleAndSubtitleForPdf = (title, subtitle, pageBreak = null, smallTable) => {
  const titlePart = {
    text: title,
    bold: true,
    fontSize: smallTable ? 10 : 14,
    alignment: smallTable ? 'left' : 'center',
    pageOrientation: 'landscape',
    marginTop: 10,
    marginBottom: 5,
    // tocItem: 'subToc',
    pageBreak,
    mcTitle: title
  }

  const subtitlePart = {
    text: subtitle,
    fontSize: smallTable ? 9 : 10,
    alignment: smallTable ? 'left' : 'center',
    pageOrientation: 'landscape',
    marginTop: 5,
    marginBottom: 10
  }

  return [titlePart, subtitlePart]
}

const generateTableTitleForPdf = (title, pageBreak = null, smallTable) => {
  return {
    text: title,
    bold: true,
    fontSize: smallTable ? 10 : 14,
    alignment: smallTable ? 'left' : 'center',
    pageOrientation: 'landscape',
    marginTop: 10,
    marginBottom: 5,
    pageBreak,
    mcTitle: title
  }
}

const generateTableSubTitleForPdf = (subtitle, pageBreak = null, smallTable) => {
  return {
    text: subtitle,
    fontSize: smallTable ? 9 : 10,
    alignment: smallTable ? 'left' : 'center',
    pageOrientation: 'landscape',
    marginTop: 5,
    marginBottom: 10
  }
}

const pdfTableStyle = {
  table: {
    alignment: 'center',
    margin: [0, 5, 0, 5]
  },
  headerRow: {
    fillColor: '#f2f2f2',
    bold: true,
    fontSize: 14
  }
}

const generateDataTableContentForPdf = (columns, content, autoWidth = false, pageBreak = null, explanation = '') => {
  columns = columns.filter(item => item !== false)

  if (!content || !content.length) {
    return noDataContent()
  }

  let tableHead = extractTableHead(columns)
  const tableBody = transformTableBody(content, columns)

  const widths = autoWidth ? columns.map(() => 'auto') : columns.map(column => column.width ?? 'auto')

  tableHead = tableHead.map(item => ({ text: item, bold: true }))

  return {
    table: {
      widths,
      body: [tableHead, ...tableBody],
      style: pdfTableStyle,
      headerRows: 1
    },
    fontSize: 10,
    alignment: 'center',
    explanation,
    layout: {
      hLineColor: (i, node) => {
        return (i === 0 || i === node.table.body.length) ? '#c5c5c5' : '#c5c5c5'
      },
      vLineColor: (i, node) => {
        return (i === 0 || i === node.table.widths.length) ? '#c5c5c5' : '#c5c5c5'
      },
      paddingLeft: (i, node) => { return (i === 0) ? 5 : 2 },
      paddingRight: (i, node) => { return (i === 0) ? 5 : 2 },
      paddingTop: (i, node) => { return (i === 0) ? 5 : 2 },
      paddingBottom: (i, node) => { return (i === 0) ? 5 : 2 },
      fillColor: function (rowIndex, node, columnIndex) {
        if (rowIndex === 0) return '#a6b2ff'
        return (rowIndex % 2 === 0) ? '#e3e7ff' : '#fff'
      }
    },
    pageBreak
  }
}

const extractTableHead = (columns) => {
  const translationKeys = columns.map(column => {
    if (typeof column === 'boolean') { return undefined }
    if (typeof column.name.props?.children === 'string' || typeof column.name.props?.children === 'number') {
      return column.name.props.children
    } else if (typeof column.name === 'object' && column.name.props && column.name.props.children) {
      const stringChildren = column.name.props.children.map(child => typeof child === 'string' ? child : child === 'span' ? child : '')
      return stringChildren.join('')
    }
    return ''
  })

  return translationKeys
}

const transformTableBody = (content, columns) => {
  const transformedContent = []

  content?.forEach((item) => {
    const transformedRow = []

    columns.forEach((column) => {
      if (typeof column === 'boolean') return
      const cellValue = column.selector(item)

      if (typeof cellValue !== 'object') {
        transformedRow.push({
          text: cellValue,
          alignment: column.right ? 'right' : 'left'
        })
      } else {
        if (cellValue.type === 'a' && cellValue.props.href) {
          transformedRow.push({
            text: cellValue.props.href,
            link: cellValue.props.href,
            linkTarget: '_blank',
            decoration: 'underline',
            decorationStyle: 'dashed',
            alignment: 'left'
          })
        } else if (cellValue.type === 'img') {
          cellValue.props.src
            ? transformedRow.push({
              image: GROWTH_ICONS_BASE64[cellValue.props.src],
              width: 10,
              height: 10,
              alignment: 'center'
            })
            : transformedRow.push('')
        } else if (cellValue.type?.name === 'Icon') {
          switch (cellValue.props.name) {
            case 'arrow-up':
              transformedRow.push({
                image: GROWTH_ICONS_BASE64['/assets/icons/up.svg'],
                width: 10,
                height: 10,
                alignment: 'center'
              })
              break
            case 'arrow-down':
              transformedRow.push({
                image: GROWTH_ICONS_BASE64['/assets/icons/down.svg'],
                width: 10,
                height: 10,
                alignment: 'center'
              })
              break
            default:
              transformedRow.push('')
          }
        } else {
          transformedRow.push('')
        }
      }
    })

    transformedContent.push(transformedRow)
  })

  return transformedContent
}

const noDataContent = () => {
  return {
    table: {
      widths: ['*'],
      body: [[{ text: i18n.t('no_option'), alignment: 'center', fillColor: '#f3f3f3' }]]
    },
    fontSize: 10,
    pageOrientation: 'landscape',
    margin: [0, 5, 0, 5]
  }
}

const generatePdfTableFromObjects = (data, headers, addHeader = true, isBigSize, isPortrait) => {
  let keys = Object.keys(headers)
  let headerLabels = keys?.map(key => ({ text: headers[key], bold: true }))

  if (headers instanceof Map) {
    keys = Array.from(headers.keys())
    headerLabels = keys?.map(key => ({ text: headers.get(key), bold: true }))
  }

  if (!data || !data.length) {
    return noDataContent()
  }

  const body = data?.map((obj, index) => {
    const customObjColumns = ['preferentialTariffs', 'complementaryNotes']
    return keys?.map(key => {
      if (!customObjColumns.includes(key) && Array.isArray(obj[key]) && obj[key].length > 1) {
        return {
          table: {
            widths: ['auto'],
            heights: 40,
            body: obj[key].map((item, index) => [{
              text: item ?? '',
              border: index !== obj[key].length - 1 ? [false, false, false, true] : [false, false, false, false]
            }])
          },
          layout: {
            hLineColor: (i, node) => {
              return (i === 0 || i === node.table.body.length) ? '#c5c5c5' : '#c5c5c5'
            },
            vLineColor: (i, node) => {
              return (i === 0 || i === node.table.widths.length) ? '#c5c5c5' : '#c5c5c5'
            }
          }
        }
      }

      let cleanedValue
      let isNumeric
      if (typeof obj[key] === 'string' && (obj[key].includes('%'))) {
        cleanedValue = obj[key].replace(/%/g, '')
      } else if (typeof obj[key] === 'string' && obj[key].includes('/')) {
        isNumeric = false
      } else {
        cleanedValue = obj[key]
      }
      const value = parseInt(cleanedValue)
      isNumeric = !isNaN(value) || obj[key] === 'Infinity' || obj[key] === 'NaN' || obj[key] === '-'
      if (['complementaryNotes', 'tradeAgreements', 'governmentControls'].includes(key) && obj?.[key] && typeof obj[key] === 'object') {
        const text = obj[key] && typeof obj[key] === 'object'
          ? Object.keys(obj[key])?.map((item, index) => {
            return `${item}:\n ${
              (obj[key][item]?.map((innerItem, innerIndex) =>
                (Object.keys(innerItem)?.map(innerItemKey => `${camelToFlat(innerItemKey)}: ${innerItem?.[innerItemKey]}`)).join('\n')))
            }`
          }).join('\n')
          : null
        return {
          text: text || '',
          alignment: 'left'
        }
      } else if (key === 'preferentialTariffs' && obj?.[key] && typeof obj[key] === 'object' && Array.isArray(obj[key])) {
        const text = obj[key]?.map((item) => (`${item?.countryGroupList} : ${item?.dutyRate}`))
        return {
          text: text?.join('\n') || '',
          alignment: 'left'
        }
      } else if (obj?.[key] && typeof obj[key] === 'object') {
        const text = Object.keys(obj[key])?.map((item, index) => `${item} : ${obj[key]?.[item]}`)
        return {
          text: text?.join('\n') || '',
          alignment: 'left'
        }
      } else {
        return {
          text: obj[key] || '',
          alignment: isNumeric ? 'right' : 'left'
        }
      }
    })
  })

  const widthsBigSize = headerLabels.map((value, key) => {
    if ([1].includes(key)) return '*'
    else return 'auto'
  })

  const fixedWidth = 120
  const widths = new Array(headerLabels.length).fill(fixedWidth)

  return {
    table: {
      widths: isBigSize ? widthsBigSize : widths,
      body: addHeader ? [headerLabels, ...body] : body,
      style: pdfTableStyle,
      headerRows: 1
    },
    fontSize: 10,
    pageOrientation: isPortrait ? 'portrait' : 'landscape',
    margin: [0, 20, 0, 20],
    layout: {
      hLineColor: (i, node) => {
        return (i === 0 || i === node.table.body.length) ? '#c5c5c5' : '#c5c5c5'
      },
      vLineColor: (i, node) => {
        return (i === 0 || i === node.table.widths.length) ? '#c5c5c5' : '#c5c5c5'
      },
      paddingLeft: (i, node) => { return (i === 0) ? 5 : 2 },
      paddingRight: (i, node) => { return (i === 0) ? 5 : 2 },
      paddingTop: (i, node) => { return (i === 0) ? 5 : 2 },
      paddingBottom: (i, node) => { return (i === 0) ? 5 : 2 },
      fillColor: function (rowIndex, node, columnIndex) {
        if (rowIndex === 0) return '#a6b2ff'
        return (rowIndex % 2 === 0) ? '#e3e7ff' : '#fff'
      }
    }
  }
}

const generateFootnotes = (cell) => {
  if (!cell.data.footnotes?.length) return <span key={'footnotes-' + cell.data.id}>{cell.value}</span>

  const footnoteSpans = []
  for (const footnote of cell.data.footnotes) {
    if (footnote.columns.includes(cell.column.dataField)) {
      const span = (
        <span className="article-footnote" title={footnote.value} key={`footnote-${footnote.id}`}>
          {footnote.marker}
        </span>
      )
      footnoteSpans.push(span)
    }
  }

  return (
    <span key={'footnotes-' + cell.data.id}>
      {cell.value} {footnoteSpans}
    </span>
  )
}

const generateMarketChangeChartForPdf = (capturedImagesData, marketChangesDivIds, divNumbers, titles, explanations) => {
  const graphics = []
  const tables = []
  for (const divNumber of divNumbers) {
    if (cleanseDataForPdf(capturedImagesData[divNumber], CONSTANTS.TYPE.IMAGE)) {
      if (capturedImagesData[divNumber]) {
        graphics.push({ text: '', pageBreak: divNumber === 2 ? null : 'before' })
        graphics.push({
          image: capturedImagesData[divNumber],
          pageOrientation: 'landscape',
          marginTop: 15,
          alignment: 'center',
          width: 600,
          height: 400,
          mcTitle: titles[divNumber]
        })
        graphics.push(...generateExplanationFooterForPdf(explanations[divNumber]))
      }
    }
  }

  for (const countryData of exportingMarketChangeChart[marketChangesDivIds['div' + divNumbers[0]]]) {
    tables.push(McPageHelpers.generatePdfTableFromObjects(countryData, {
      _countryName: i18n.t('country'),
      _date: i18n.t('date'),
      monthly: i18n.t('monthly'),
      yearly: i18n.t('yearly'),
      raw: i18n.t('value_with_dollar')
    }, true))
  }

  return [
    ...graphics,
    {
      text: '',
      pageBreak: 'after'
    },
    ...tables
  ]
}

const generateDateText = (value, type = McPageHelpers.KEY.MONTHLY) => {
  const date = value?.toString() ?? '-'
  const lastTwoCharacter = date.slice(-2)
  const firstFourCharacter = date.slice(0, 4)
  const result = McPageHelpers.getMonthName(lastTwoCharacter)

  if (type === McPageHelpers.KEY.MONTHLY) {
    return firstFourCharacter + '/' + i18n.t(`months.${result}`)
  }
  return i18n.t(`months.${result}`)
}

const getPriceTableDataForPdf = (headerPriceTable) => {
  const priceDivIds = {
    div1: 'annualAverageImportUnitPricesMapGraph_forPdf',
    div2: 'priceAnalysisMultiValue_forPdf',
    div3: 'hsTotalImportCurrencyXFirmNum_forPdf',
    div4: 'averagePriceXTotalImportCurrency_forPdf',
    div5: 'averagePriceChart_forPdf',
    div6: 'hsCodeChart_forPdf',
    div7: 'averagePriceXTotalImportInterest_forPdf'
  }

  const titles = [
    i18n.t('ai_sp_static_avg_price'),
    CONSTANTS.BADGE_CODES.PRICE_ANALYSIS_GRAPH_3 + ' ' + headerPriceTable,
    CONSTANTS.BADGE_CODES.PRICE_ANALYSIS_TABLE_1 + ' ' + headerPriceTable,
    CONSTANTS.BADGE_CODES.PRICE_ANALYSIS_GRAPH_4 + ' ' + i18n.t('ai_sp_static_hs_total_value_currency'),
    CONSTANTS.BADGE_CODES.PRICE_ANALYSIS_GRAPH_5 + ' ' + i18n.t('sp_filter_by_avg_price_hs_total'),
    CONSTANTS.BADGE_CODES.PRICE_ANALYSIS_GRAPH_6 + ' ' + i18n.t('sp_filter_by_avg_price'),
    CONSTANTS.BADGE_CODES.PRICE_ANALYSIS_GRAPH_7 + ' ' + i18n.t('ai_sp_static_hs_code_count'),
    CONSTANTS.BADGE_CODES.PRICE_ANALYSIS_GRAPH_8 + ' ' + i18n.t('sp_filter_by_avg_price_hs_total_percentage')
  ]

  const priceHeaders = {
    country_code: i18n.t('country_code'),
    country_name: i18n.t('country'),
    formatValue: i18n.t('sp_filter_by_avg_price')
  }

  return {
    priceDivIds,
    titles,
    priceHeaders
  }
}

const toggleAllMarketOverview = (showOrRestore = true) => {
  return new Promise((resolve, reject) => {
    if (showOrRestore) {
      const elements = document.querySelectorAll('.tab-pane:not(.active)')
      for (let i = 0; i < elements.length; i++) {
        elements[i].classList.add('active', 'for-pdf')
      }
      resolve()
    } else {
      const elementsForPdf = document.querySelectorAll('.tab-pane.for-pdf')
      for (let i = 0; i < elementsForPdf.length; i++) {
        elementsForPdf[i].classList.remove('active', 'for-pdf')
      }
      resolve()
    }
  })
}

const isLessThan = (value, maxValue, type, maximumFractionDigits, minimumFractionDigits, doRound = false) => {
  const userLocale = localeMap[localStorage.getItem('lang')] || 'en-US'
  localStorage.setItem('locale', userLocale)

  if (value < maxValue && value > 0) {
    return '<' + Number(maxValue).toLocaleString(userLocale, { style: type, currency: 'USD' })
  } else if (doRound) {
    return numToLocaleString(Math.round(value), type, false, maximumFractionDigits, minimumFractionDigits)
  } else {
    return numToLocaleString(value, type, false, maximumFractionDigits, minimumFractionDigits)
  }
}

const getSummaryTableTransformData = (data) => {
  return data?.map(entry => {
    return {
      ...entry,
      partnerCode: McPageHelpers.findCountryName(entry.partnerCode),
      totalValue: isLessThan((entry.totalValue / 1000), 1, 'decimal', 0, 0, true),
      totalWeight: isLessThan((entry.totalWeight / 1000), 1, 'decimal', 0, 0, true),
      unitPrice: McPageHelpers.numToLocaleString(entry.unitPrice, 'decimal', false, 2, 2),
      percentValue: McPageHelpers.numToLocaleString(entry.percentValue, 'percent', false, 1, 1),
      cumulativePercentValue: McPageHelpers.numToLocaleString(entry.cumulativePercentValue, 'percent', false, 1, 1),
      percentQuantity: McPageHelpers.numToLocaleString(entry.percentQuantity, 'percent', false, 1, 1),
      worldExportPercentValue: McPageHelpers.numToLocaleString(entry.worldExportPercentValue, 'percent', false, 1, 1),
      worldExportPercentQuantity: McPageHelpers.numToLocaleString(entry.worldExportPercentQuantity, 'percent', false, 1, 1),
      worldImportPercentValue: McPageHelpers.numToLocaleString(entry.worldImportPercentValue, 'percent', false, 1, 1),
      worldImportPercentQuantity: McPageHelpers.numToLocaleString(entry.worldImportPercentQuantity, 'percent', false, 1, 1),
      worldExportOrder: entry.worldExportOrder ?? '-',
      worldImportOrder: entry.worldImportOrder ?? '-'
    }
  })
}

const generateTableOfContents = () => {
  return [
    {
      text: i18n.t('toc'),
      bold: true,
      fontSize: 20,
      alignment: 'center'
    },

    {
      toc: {
        id: 'mainToc',
        title: { text: '', style: 'header' },
        textStyle: 'tocHeaderItemStyle'
      }
    }
  ]
}

const showErrorToast = (objName, status) => {
  let translateKey = null

  switch (objName) {
    case RESPONSE_OBJ_NAMES.RF_TABLE:
      translateKey = 'output.company_recommendation_results'
      break
    case RESPONSE_OBJ_NAMES.SP_TABLE:
      translateKey = 'output.trade_pattern_results'
      break
    case RESPONSE_OBJ_NAMES.SP_TABLE + SECTION_IDS.IMPORTER_COMPANIES:
      translateKey = 'output.trade_pattern_results_fa'
      break
    case RESPONSE_OBJ_NAMES.SP_GRAPH:
      translateKey = 'output.trade_pattern_graphs'
      break
    case RESPONSE_OBJ_NAMES.SP_GRAPH + SECTION_IDS.IMPORTER_COMPANIES_MAP_GRAPH:
      translateKey = 'output.trade_pattern_graphs_if'
      break
    case RESPONSE_OBJ_NAMES.SP_GRAPH + SECTION_IDS.ANNUAL_AVERAGE_IMPORT_UNIT_PRICES_MAP_GRAPH:
      translateKey = 'output.trade_pattern_graphs_fa'
      break
    case RESPONSE_OBJ_NAMES.SP_SUMMARY:
      translateKey = 'sp_summary_failed'
      break
    case RESPONSE_OBJ_NAMES.MONTHLY:
      translateKey = 'monthly_changes_failed'
      break
    case RESPONSE_OBJ_NAMES.COMTRADE_SUMMARY:
      translateKey = 'summary_tables_failed'
      break
    case RESPONSE_OBJ_NAMES.COMTRADE_MARKET_OVERVIEW:
      translateKey = 'marketreport_comtrademarketoverview_failed'
      break
    case RESPONSE_OBJ_NAMES.COMTRADE_MARKET_CHANGE:
      translateKey = 'marketreport_comtrademarketchange_failed'
      break
    case RESPONSE_OBJ_NAMES.MARKET_CHANGE:
      translateKey = 'marketreport_marketchanges_failed'
      break
    case RESPONSE_OBJ_NAMES.DUTIES:
      translateKey = 'customs_duties_failed'
      break
  }

  const toastHtml = <div className="d-flex flex-column">
    <span className="pb-1">{i18n.t(translateKey)}</span>
  </div>

  status === 'error' && toast.error(toastHtml, {
    position: 'bottom-right',
    autoClose: true,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: false
  })
}

const generateColumnsForCustomsDutiesPdf = (rawColumns, country) => {
  const columns = new Map()
  rawColumns?.forEach((column, index) => {
    if (column === 'memberCountryDuties') {
      columns.set(column, i18n.t('columns.memberCountryDuties', { country }))
    } else if (['hsCode', 'description', 'general', 'special', 'other', 'duty', 'legalBase', 'measureType', 'unit', 'importDuty', 'valueAddedTax',
      'importAdjustmentTax', 'exciseTax', 'dateOfValidity', 'rateType', 'rate', 'agreements', 'feesAndTaxes', 'drawingRatio', 'dutyRate', 'procedures',
      'preferentialTariffs', 'unitOfMeasurement', 'complementaryNotes', 'tradeAgreements', 'governmentControls', 'rateOfDuty', 'vat', 'notes', 'additionalDuty'].includes(column)) {
      columns.set(column, i18n.t('columns.' + column))
    } else if (['agreements'].includes(column)) {
      columns.set(column, column)
    } else {
      columns.set(column, column)
    }
  })
  return columns
}

const cleanseDataForPdf = (array, type = 'table') => {
  switch (type) {
    case CONSTANTS.TYPE.TABLE:
      if (typeof array === 'object' || array instanceof Array) {
        let tableObj
        if (Array.isArray(array)) {
          // eslint-disable-next-line no-prototype-builtins
          tableObj = array.find(obj => obj?.hasOwnProperty('table'))
          // eslint-disable-next-line no-prototype-builtins
        } else if (array?.hasOwnProperty('table')) {
          tableObj = array
        }
        if (tableObj && tableObj.table && Array.isArray(tableObj.table.body) && tableObj.table.body.length > 1) {
          return array
        }
        return ''
      }
      return ''
    case CONSTANTS.TYPE.IMAGE: {
      return !!array
    }
    default:
      return false
  }
}

const getColumnsName = (value, prevValue, type, onlyFirst, ratio) => {
  const date = value?.toString()
  const prevDate = prevValue?.toString()

  const lastTwoCharacter = date.slice(-2)
  const firstFourCharacter = date.slice(0, 4)
  const prevFirst = prevDate?.slice(0, 4)
  const prevLast = prevDate?.slice(-2)

  const result = i18n.t(`months.${getMonthName(lastTwoCharacter)}`)
  const prevResult = i18n.t(`months.${getMonthName(prevLast)}`)

  const seperator = ratio ? ' - ' : ' / '

  if (!onlyFirst) return firstFourCharacter
  else if (!prevValue) {
    return (result + ' ' + firstFourCharacter)
  } else if (prevValue) {
    if (type === KEY.MONTHLY) {
      return (`${result} ${firstFourCharacter}` + seperator + `${prevResult} ${prevFirst}`)
    } else {
      return firstFourCharacter + seperator + prevFirst
    }
  }
}

const generateExplanationFooter = explanation => {
  return explanation && Array.isArray(explanation) && explanation.length > 0 && (
    <div className="card-title-group mt-2">
      <div className="card-title w-100">
        <hr/>
        {explanation.map((item, index) => (
          <p key={index}>{item}</p>
        ))}
      </div>
    </div>
  )
}

const generateExplanationFooterWithWhiteBg = explanation => {
  return explanation && Array.isArray(explanation) && explanation.length > 0 && (
    <div className="card-bordered card p-3">
      {explanation.map((item, index) => (
        <p key={index}>{item}</p>
      ))}
    </div>
  )
}

const generateExplanationFooterForPdf = explanation => {
  const result = []
  if (Array.isArray(explanation) && explanation.length > 0) {
    const footerItems = explanation.map((item, index) => ({
      text: item,
      fontSize: 10,
      margin: index !== explanation.length - 1 ? [0, 10, 0, 10] : [0, 10, 0, 20],
      color: 'gray',
      italics: true
    }))

    result.push(...footerItems)
  }
  return result
}

const languageOptions = [
  { code: 'en', name: 'English', flag: EnglishFlag },
  { code: 'tr', name: 'Türkçe', flag: TurkeyFlag },
  { code: 'ar', name: 'العربية', flag: SaudiArabiaFlag }
]

const localeMap = {
  tr: 'tr-TR',
  ar: 'ar-SA',
  en: 'en-US'
}

const createLimitsArray = (limitObj, includeB2B = false) => {
  const limitMappings = {
    dailyLimit: 'limit.daily',
    totalLimit: 'limit.total',
    hsCodeFoundLimit: 'limit.hsCodeFound',
    excelDownloadLimit: 'limit.excelDownload',
    productDetailSearchLimit: 'limit.productDetailSearch',
    excelFirmDownloadLimit: 'limit.excelFirmDownload',
    b2bCampaignLimit: 'limit.b2bCampaign',
    b2bTotalEmailLimit: 'limit.b2bTotalEmail',
    b2bProductDetailSearchLimit: 'limit.b2bProductDetailSearch'
  }

  return Object.entries(limitMappings)
    .filter(([key]) => includeB2B || !key.startsWith('b2b'))
    .map(([key, label]) => {
      const usedKey = key.startsWith('b2b')
        ? `${key.slice(0, 3)}Used${key.charAt(3).toUpperCase() + key.slice(4)}`
        : `used${key.charAt(0).toUpperCase() + key.slice(1)}`

      const total = limitObj[key]
      const used = limitObj[usedKey]

      if (total === undefined || used === undefined) return null

      return { key, label, usedKey, total, used }
    })
    .filter(Boolean)
}

const getAllowedSearchCountries = user => {
  const rule = user.rules.find(r => r.type === 'SEARCH_COUNTRY_SET')
  return rule?.parameters?.allowedSearchCountries
}

const McPageHelpers = {
  MOUNTAIN_CHART_TYPE,
  COUNT_FILTERS,
  GROWTH_ICONS,
  REGISTER_STATES,
  FILTER_BUTTON_IDS,
  HAS_MIN_MAX_IDS,
  UNITS,
  UNIT_NUMBERS,
  HEAT_MAP_PARAMS,
  MESSAGE_TYPES,
  MESSAGE_TYPES_NEGATIVE,
  SECTION_IDS,
  KEY,
  MIN_MAX,
  REQUEST_STATUSES,
  FOR_PDF_ID,
  FOR_PDF_CONTENT_ID,
  createAboutSection,
  getYearAndMonth,
  generateCountFilterValue,
  generateYearChartData,
  generateYearModalChartData,
  getCompanyLogisticFirmStatus,
  numToLocaleString,
  numDivisionByThousand,
  getCountryDataByCode,
  getFilterCondition,
  showLoadingWithTimer,
  sanitizeQuantity,
  generateCardHyperlink,
  mcDataTableCustomSort,
  findCountryName,
  findSelectedFirmDetails,
  unitToNumber,
  getBarChartFilterValues,
  getMonthName,
  handleError,
  handleRawError,
  showFilterNotification,
  scrollToElement,
  generatePriceAnalysisMultiValueAxes,
  checkPasswordValidity,
  PDFExport,
  captureImageById,
  generateDataTableContentForPdf,
  generateTableTitleForPdf,
  generateSectionTitle,
  generateFootnotes,
  generatePdfTableFromObjects,
  generateMarketChangeChartForPdf,
  generateDateText,
  getPriceTableDataForPdf,
  toggleAllMarketOverview,
  isLessThan,
  getSummaryTableTransformData,
  generateTableOfContents,
  generateTableTitleAndSubtitleForPdf,
  showErrorToast,
  generateTableSubTitleForPdf,
  generateColumnsForCustomsDutiesPdf,
  cleanseDataForPdf,
  generateSubTitle,
  getColumnsName,
  generateExplanationFooter,
  generateExplanationFooterForPdf,
  generateExplanationFooterWithWhiteBg,
  getAllowedSearchCountries,
  createLimitsArray,
  languageOptions,
  localeMap
}

export default McPageHelpers
